<template>
  <section class="section--pd section--pb-xlg">
    <div class="inner">
      <div class="tutorial__banner">
        <router-link to="/tutorial">
          <img
            src="assets/img/tutorial_banner.png"
            alt="tutorial banner"
          >
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TutorialBanner'
}
</script>
